import React from "react";
import { PanelScreenType } from "../panel.types";
import logo from "../assets/images/logo.webp";
import changeScreenSound from "../assets/audio/change-screen.wav";
import { useAudioEffects } from "../../../hooks/use-audio-effects";

interface Props {
  className?: string;
  logoSrc?: string;
  title: string;
  description: string;
  onClose: () => void;
  onScreenChange: (screen: PanelScreenType) => void;
  activeScreen: PanelScreenType;
}

const PanelHeader: React.FC<Props> = ({
  className,
  logoSrc = logo,
  title = "Insert title",
  description = "Insert description",
  onClose,
  activeScreen,
  onScreenChange,
}) => {
  const { playEffect } = useAudioEffects();

  return (
    <div
      className={`flex items-center justify-between border-b-[1px] border-white/5 pb-5 ${className}`}
    >
      {/** Logo */}
      <img
        src={logoSrc}
        alt="logo"
        width={148}
        height={53}
        draggable={false}
        className="select-none"
      />

      {/** Heading & Screen buttons */}
      <div className="flex-1 px-8 flex items-center space-x-5">
        <div className="max-w-[180px] min-w-[130px]">
          <h1 className="text-white font-bold text-[24px] chakra-petch-font leading-[1]">
            {title}
          </h1>
          <p className="text-white/50 text-[12px]">{description}</p>
        </div>

        <div className="bg-white/5 rounded-md p-2">
          {[
            { value: "panel", name: "Car Panel" },
            { value: "radio", name: "Car Radio" },
          ]?.map(({ value, name }) => {
            const isActive = value === activeScreen;

            return (
              <button
                className={`border-[2px] p-1 px-2 rounded-sm ${isActive ? "text-white bg-[#137FE3]/60 border-[#137FE3]" : "text-white/50 border-transparent"} text-[14px]`}
                title={value}
                onClick={() => {
                  playEffect(changeScreenSound);
                  onScreenChange(value as PanelScreenType);
                }}
              >
                {name}
              </button>
            );
          })}
        </div>
      </div>

      {/** Close */}
      <button
        title="Close"
        onClick={onClose}
        className="bg-[#FF1F1F]/5 rounded-md border-[1px] border-[#FF1F1F]/50 px-[8px] py-[5px] flex items-center space-x-2 text-[12px]"
      >
        <div className="bg-[#FF1F1F]/15 rounded-sm text-[#FF1F1F] px-1">
          ESC
        </div>

        <span className="text-white/90">CLOSE</span>
      </button>
    </div>
  );
};

export default PanelHeader;
